import { gql } from 'graphql-tag';

// =============================================================================
// Program-Link Visitor Tracking — GraphQL operations against the Nexus backend
// =============================================================================
// recordProgramVisit : public, fire-and-forget. One call per share-link load.
// programVisitStats  : owner-gated. Reach analytics for a creator's program.
// =============================================================================

export const RECORD_PROGRAM_VISIT_MUTATION = gql`
  mutation RecordProgramVisit($input: RecordProgramVisitInput!) {
    recordProgramVisit(input: $input) {
      recorded
    }
  }
`;

export const PROGRAM_VISIT_STATS_QUERY = gql`
  query ProgramVisitStats($programId: ID!) {
    programVisitStats(programId: $programId) {
      programId
      totalViews
      uniqueVisitors
      joins
      conversionRate
      trend {
        date
        views
        uniqueVisitors
      }
      topSources {
        label
        count
      }
      geo {
        label
        count
      }
      devices {
        label
        count
      }
    }
  }
`;

// ------- Client-side shapes (mirror the backend DTOs) -------

export interface RecordProgramVisitInput {
  programId: string;
  visitorId: string;
  referrer?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  language?: string;
  timezone?: string;
}

export interface VisitTrendPoint {
  date: string;
  views: number;
  uniqueVisitors: number;
}

export interface VisitBreakdownItem {
  label: string;
  count: number;
}

export interface ProgramVisitStats {
  programId: string;
  totalViews: number;
  uniqueVisitors: number;
  joins: number;
  conversionRate: number;
  trend: VisitTrendPoint[];
  topSources: VisitBreakdownItem[];
  geo: VisitBreakdownItem[];
  devices: VisitBreakdownItem[];
}
